import * as actionTypes from "Consts/actionsTypes";

const defaultState = {
    items: [],
    TotalCount: 0,
    query: "",
    loading: false,
    types: [],
    culture: "",
    startPageId: "",
    currentPageId: "",
    searchHitsText: "",
    takeNrFromPage: 0,
    isMixedContent: false,
};

export const search = (state = defaultState, action) => {
    switch (action.type) {
        case actionTypes.SEARCH__LOADING:
            state = {
                ...state,
                loading: action.payload,
            };
            break;
        case actionTypes.SEARCH__GET:
            const {payload} = action;
            state = {
                ...state,
                query: payload.query,
                items: payload.cleanResult ? payload.items : [...state.items, ...payload.items],
                TotalCount: payload.TotalCount,
                types: payload.types,
                culture: payload.culture,
                startPageId: payload.startPageId,
                currentPageId: payload.currentPageId,
                searchHitsText: payload.searchHitsText,
                takeNrFromPage: payload.takeNrFromPage,
                isMixedContent: payload.isMixedContent,
            };
            break;
        case actionTypes.SEARCH__MORE:
            const {payload: payloadmore} = action;
            state = {
                ...state,
                query: payloadmore.query,
                items: payloadmore.cleanResult ? payloadmore.items : [...state.items, ...payloadmore.items],
                TotalCount: payloadmore.TotalCount,
                types: payloadmore.types,
                culture: payloadmore.culture,
                startPageId: payloadmore.startPageId,
                currentPageId: payloadmore.currentPageId,
                searchHitsText: payloadmore.searchHitsText,
                takeNrFromPage: payloadmore.takeNrFromPage,
                isMixedContent: payloadmore.isMixedContent,
            };
            break;
    }
    return state;
};
